import React from 'react';
import group from '../../rtds team2-10.png'

class AboutPage extends React.Component {
    render() {
        return(
            <div className=""> 

                <div className='about'>
                    {/* <div>
                        <img src={group} alt='about-cover' className='about-cover-img'/>
                    </div> */}
                    <div className="flex-container ">
                        <div className='about-content'>
                            <h3>What happens in the studio</h3>
                            <p>
                            Every project undergoes in a four step process before producing its output - Planting, Watering, Fertilizing, and Harvesting. Each step 
                            is discussed as follows. 
                            </p><br/>
                        </div>
                    </div>
                    <br/>
                    <div className="flex-container about-content">
                        <div className="flex-container">
                            <div className="flex-item">
                                <img src="https://res.cloudinary.com/doddfudab/image/upload/v1556022289/rtds_work/Assets/rtds_process-09.png" alt="planting" className='about-found-img'/>    
                            </div>
                            <div className="flex-item about-found">
                                <h4>Planting</h4>
                                <div className="about-found-txt">At planting, it is important to understand what the client wants. In here we gather inspirations
                                and discuss with the client what fruit they want to produce. </div>   
                            </div>
                        </div>
                    </div>
                    <div style={{paddingTop:'30px'}} className="about-content">
                        <div className="flex-container-r">
                            <div className="flex-item about-found">
                                <h4>Watering</h4>
                                <div className="about-found-txt">After the discussion, we quote the project before proceeding to actualizing the product. The number of studies shown to clients
                                depend on the discussion during planting. Included in this process is showing the studies to be also approved before finalizing.</div>   
                            </div>
                            <div className="flex-item">
                                <img src="https://res.cloudinary.com/doddfudab/image/upload/v1556022289/rtds_work/Assets/rtds_process-11.png" alt="watering" className='about-found-img'/>    
                            </div>
                        </div>
                    </div>
                    <div style={{paddingTop:'30px'}} className="flex-container about-content">
                        <div className="flex-container">
                            <div className="flex-item">
                                <img src="https://res.cloudinary.com/doddfudab/image/upload/v1556022289/rtds_work/Assets/rtds_process-10.png" alt="fertilizing" className='about-found-img'/>    
                            </div>
                            <div className="flex-item about-found">
                                <h4>Fertilizing</h4>
                                <div className="about-found-txt">After approval, it is important to us to give a quality produce. With that we polish everything before executing the product.</div>   
                            </div>
                        </div>
                    </div>
                    <div style={{paddingTop:'30px'}} className="about-content">
                        <div className="flex-container-r">
                            <div className="flex-item about-found">
                                <h4>Harvesting</h4>
                                <div className="about-found-txt">The plant has finally bloomed, the last process includes execution and maintenance of the product that was planted.</div>   
                            </div>
                            <div className="flex-item">
                                <img src="https://res.cloudinary.com/doddfudab/image/upload/v1556022289/rtds_work/Assets/rtds_process-12.png" alt="harvesting" className='about-found-img'/>    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutPage;


// WEBPACK FOOTER //
// ./src/components/pages/ProcessPage.js